/**
 * agency Group
 * @param fb : FormBuilder
 */
export function agencyGroup (fb :any):any {
    return fb.group({
        code: [''],
        name: [''],
        telephone: ['']
    })
}
